import { useState } from "react";
import { CheckCircle, CalendarBlank } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
  AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { fmtDate } from "../serviceApi";

// Confirmation for "Mark Completed / Acknowledge" (kind=complete) or "Move due date" (kind=reschedule).
export function OccurrenceActionDialog({ kind, schedule, busy, onCancel, onConfirm }) {
  const [date, setDate] = useState("");
  const [note, setNote] = useState("");
  const complete = kind === "complete";
  const ok = complete || (date && date !== schedule?.next_due && note.trim().length >= 3);
  return (
    <AlertDialog open={!!kind} onOpenChange={(v) => !v && onCancel()}>
      <AlertDialogContent data-testid={`occurrence-${kind || "none"}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>{complete ? "Mark this occurrence completed?" : "Move the due date?"}</AlertDialogTitle>
          <AlertDialogDescription>
            {complete
              ? <>The occurrence due {fmtDate(schedule?.next_due)} is recorded as <b>Completed</b> with your name and time, a completed service entry is added to history, and the schedule advances one {schedule?.frequency === "annually" ? "year" : schedule?.frequency === "monthly" ? "month" : "week"}.</>
              : <>The occurrence due {fmtDate(schedule?.next_due)} is recorded as <b>Rescheduled</b> (not completed). The new date becomes the next due date.</>}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-2">
          <div>
            <Label>{complete ? "Date the service was done (optional — default today)" : "New due date *"}</Label>
            <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid={`occurrence-${kind}-date`} />
          </div>
          <div>
            <Label>{complete ? "Note (optional)" : "Reason *"}</Label>
            <Textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} placeholder={complete ? "e.g. Inspected by Acme Fire, tag renewed" : "e.g. Vendor booked for next year"} data-testid={`occurrence-${kind}-note`} />
          </div>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`occurrence-${kind}-cancel`}>Cancel</AlertDialogCancel>
          <Button disabled={busy || !ok} onClick={() => onConfirm(complete ? { service_date: date || null, notes: note } : { due_date: date, reason: note })}
            className={complete ? "bg-emerald-600 hover:bg-emerald-700 text-white" : "bg-orange-500 hover:bg-orange-600 text-white"} data-testid={`occurrence-${kind}-confirm`}>
            {complete ? <><CheckCircle size={14} className="mr-1" />Mark completed</> : <><CalendarBlank size={14} className="mr-1" />Move due date</>}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
